import React from "react";
import ReactModal from "react-modal";

import { Close } from "assets/icons";
import { IconButton } from "components/icon-button/IconButton";
import { ButtonTheme } from "types";
import { i18nService } from "services";

interface ModalProps {
  handleClose: () => void;
  theme?: "light" | "dark";
}

export const Modal: React.FC<ModalProps> = ({
  handleClose,
  theme = "dark",
  children,
}) => {
  return (
    <ReactModal
      isOpen
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onRequestClose={handleClose}
      className={`modal is-${theme}`}
      overlayClassName={`modal-overlay is-${theme}`}
      appElement={document.body}
    >
      {children}
      <IconButton
        className="modal__close"
        label={i18nService.copy["a11y.close"]}
        Icon={Close}
        onClick={handleClose}
        theme={ButtonTheme.secondary}
      />
    </ReactModal>
  );
};
